import productService from '../api';
import { 
  SET_PRODUCT, 
  SET_PLUGIN_INFO,
  SET_BRIEFS,
  SET_BRIEFS_LOADING,
} from './product.constants';

export const getPluginTC = (type) => {
  return async (dispatch) => {
    try {
      const data = await productService.getPlugin(type);

      if(data?.status === 200) {
        const blob = new Blob([data.data], {
          type: 'application/zip',
        });

        return blob;
      }

      throw new Error("The server did not return a result");
    } catch (error) {
      console.log(error);
      alert('Error download file.', error)
    }
  }
}

export const getPluginInfoTC = () => {
  return async (dispatch) => {
    try {
      const resp = await productService.getPluginInfo();
      
      dispatch(setPluginInfoAC(resp?.data));
    } catch (error) {
      console.log(error);
    }
  }
}

export const getBriefsTC = () => {
  return async (dispatch) => {
    try {
      const resp = await productService.getBriefs();

      dispatch(setBriefsAC(resp?.data));
    } catch (error) {
      console.log(error);
    }
  }
}

//ACTIONS
export const setProductAC = (payload) => {
  return {
    type: SET_PRODUCT,
    payload,
  };
};

export const setPluginInfoAC = (payload) => {
  return {
    type: SET_PLUGIN_INFO,
    payload,
  };
};

export const setBriefsAC = (payload) => {
  return {
    type: SET_BRIEFS,
    payload,
  };
};

export const setBriefsLoadingAC = (payload) => {
  return {
    type: SET_BRIEFS_LOADING,
    payload,
  };
}
